export default __webpack_public_path__ + "src/design/components/Icon/assets/svg_icon_male.svg";